import { useMutation, useQueryClient } from '@tanstack/react-query';

import { organizationsApi } from '../api/organizations-api';

import { organizationKeys } from './organization-keys';

/** Moves the invitation to a corrected address and sends it there; the old link stops working. */
export function useUpdateOwnerInvite(organizationId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (email: string) => organizationsApi.updateOwnerInvite(organizationId, email),
    meta: { successMessage: 'organizations:toasts.ownerEmailFixed', silentError: true },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: organizationKeys.detail(organizationId) }),
  });
}
